export default (state = {}, action = {}) => {
  const {type, payload = {}} = action;
  switch (type) {
    default: {
      if (payload.termination_reasons) {
        return {...state, ...payload.termination_reasons};
      }
      return state;
    }
  }
};
